export enum BROWSER_PERMISSION_STATES {
  prompt = 'prompt',
  denied = 'denied',
  granted = 'granted',
}
